import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function launchEnrollment(intakeId, url) {
  // Records a first-class hand-off event (best-effort), then opens the destination.
  try {
    if (intakeId) await api.post(`/medicare/intakes/${intakeId}/handoff`);
  } catch (e) {
    // non-blocking
  }
  if (url) window.open(url, "_blank", "noopener");
}

export default api;
